import React from "react";
import { Link } from "react-router-dom";
import { Menu, ArrowUpRight } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { NAV_LINKS } from "@/data/site";
import Logo from "@/components/Logo";

/**
 * Reusable slide-out navigation menu.
 * `trigger` lets each page provide its own hamburger button styling
 * (an invisible overlay on the home hero, a visible icon on inner pages).
 */
export default function AppMenu({ trigger }) {
  const [open, setOpen] = React.useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{trigger}</SheetTrigger>
      <SheetContent
        side="right"
        className="w-[300px] sm:w-[360px] border-l-0 bg-[#081831] text-white p-0"
      >
        <SheetHeader className="px-7 pt-8 pb-4 text-left">
          <SheetTitle asChild>
            <div>
              <Logo />
            </div>
          </SheetTitle>
        </SheetHeader>
        <nav className="flex flex-col px-4">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              onClick={() => setOpen(false)}
              className="group flex items-center justify-between rounded-lg px-3 py-4 text-lg font-medium text-white/85 transition-colors hover:bg-white/5 hover:text-[#f2b743]"
            >
              <span>{link.label}</span>
              <ArrowUpRight className="h-5 w-5 opacity-0 -translate-x-1 transition-all duration-200 group-hover:opacity-100 group-hover:translate-x-0" />
            </Link>
          ))}
        </nav>
        <div className="mt-6 px-7">
          <Link
            to="/audit"
            onClick={() => setOpen(false)}
            className="flex w-full items-center justify-center rounded-lg bg-[#e9a31e] px-5 py-3 text-sm font-bold text-[#0a1f3d] transition-colors hover:bg-[#f2b743]"
          >
            Book Your Free Digital Audit
          </Link>
        </div>
      </SheetContent>
    </Sheet>
  );
}

export { Menu };
